import { doc, getDoc } from 'firebase/firestore';

const SUPPORTED_COLLECTION = 'users';

const normalizeEmail = (email) => (email ?? '').trim();

const buildCandidateIds = (email) => {
  const trimmed = normalizeEmail(email);
  if (!trimmed) {
    return [];
  }

  const lower = trimmed.toLowerCase();
  if (lower === trimmed) {
    return [trimmed];
  }

  return [trimmed, lower];
};

export const fetchProvisionedUser = async (db, rawEmail) => {
  const candidates = buildCandidateIds(rawEmail);
  if (!candidates.length) {
    return null;
  }

  for (const candidate of candidates) {
    const snapshot = await getDoc(doc(db, SUPPORTED_COLLECTION, candidate));
    if (snapshot.exists()) {
      return {
        email: candidates[0],
        data: snapshot.data() ?? {},
      };
    }
  }

  return null;
};

export const hasModuleAccess = (userData, system) => {
  if (!system) {
    return true;
  }

  const accessList = Array.isArray(userData?.access) ? userData.access : [];
  return accessList.includes(system);
};

/**
 * Returns the tier string for the given user document data.
 * Tier '1' indicates access to cloud features (GM).
 * Any other value (e.g. '2', undefined) means limited / no cloud access.
 */
export const getUserTier = (userData) => {
  return userData?.tier ?? null;
};

/**
 * Fetch the provisioned user's tier directly from Firestore.
 * Returns '1', '2', or null if the user document is not found.
 */
export const fetchUserTier = async (db, rawEmail) => {
  const record = await fetchProvisionedUser(db, rawEmail);
  if (!record) return null;
  return getUserTier(record.data);
};
